"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationLanguageStore = exports.usePreferencesStore = exports.resetPreferencesLocally = exports.getPreferenceEnabledLocally = exports.setPreferenceEnabledLocally = exports.upsertPreference = exports.getNotificationLanguage = exports.getUnreadCountFromPreferences = exports.getPreferences = exports.getKinds = exports.getPreferencesUserId = exports.isPreferencesInitialised = exports.initKinds = exports.initPreferences = exports.getPreferencesSnapshot = exports.subscribePreferences = void 0;
var react_1 = require("react");
var state = {
    initialised: false,
    userId: null,
    unreadCount: 0,
    kinds: [],
    preferences: [],
    notificationLanguage: 'en',
};
var listeners = new Set();
var emit = function () {
    listeners.forEach(function (l) { return l(); });
};
var setState = function (patch) {
    state = __assign(__assign({}, state), patch);
    emit();
};
var subscribePreferences = function (listener) {
    listeners.add(listener);
    return function () { return listeners.delete(listener); };
};
exports.subscribePreferences = subscribePreferences;
var getPreferencesSnapshot = function () { return state; };
exports.getPreferencesSnapshot = getPreferencesSnapshot;
/**
 * Bootstrapping (server-injected JSON)
 * - Call once on preferences page to hydrate kinds + preferences + unreadCount.
 */
var initPreferences = function (payload) {
    var _a, _b;
    if (state.initialised)
        return;
    setState({
        initialised: true,
        userId: payload.userId,
        unreadCount: payload.unreadCount,
        kinds: (_a = payload.kinds) !== null && _a !== void 0 ? _a : [],
        preferences: (_b = payload.preferences) !== null && _b !== void 0 ? _b : [],
        notificationLanguage: payload.notification_language,
    });
};
exports.initPreferences = initPreferences;
/**
 * Seed kinds independently of the full preferences bootstrap.
 * Safe to call from any page that injects the kinds script tag.
 * Does not set `initialised` so the full preferences hydration still runs on the preferences page.
 */
var initKinds = function (kinds) {
    if (state.kinds.length > 0)
        return;
    setState({ kinds: kinds });
};
exports.initKinds = initKinds;
var isPreferencesInitialised = function () { return state.initialised; };
exports.isPreferencesInitialised = isPreferencesInitialised;
var getPreferencesUserId = function () { return state.userId; };
exports.getPreferencesUserId = getPreferencesUserId;
var getKinds = function () { return state.kinds; };
exports.getKinds = getKinds;
var getPreferences = function () { return state.preferences; };
exports.getPreferences = getPreferences;
var getUnreadCountFromPreferences = function () { return state.unreadCount; };
exports.getUnreadCountFromPreferences = getUnreadCountFromPreferences;
var getNotificationLanguage = function () { return state.notificationLanguage; };
exports.getNotificationLanguage = getNotificationLanguage;
// Helpers
var prefKey = function (p) {
    return "".concat(p.user_id, ":").concat(p.kind, ":").concat(p.channel);
};
var upsertPreference = function (p) {
    var key = prefKey(p);
    var idx = state.preferences.findIndex(function (x) { return prefKey(x) === key; });
    if (idx >= 0) {
        var curr = state.preferences[idx];
        if (curr.enabled === p.enabled)
            return;
        setState({
            preferences: state.preferences.map(function (x, i) { return (i === idx ? __assign(__assign({}, x), p) : x); }),
        });
        return;
    }
    setState({ preferences: __spreadArray(__spreadArray([], state.preferences, true), [p], false) });
};
exports.upsertPreference = upsertPreference;
var setPreferenceEnabledLocally = function (args) {
    (0, exports.upsertPreference)({
        user_id: args.userId,
        kind: args.kind,
        channel: args.channel,
        enabled: args.enabled,
    });
};
exports.setPreferenceEnabledLocally = setPreferenceEnabledLocally;
var getPreferenceEnabledLocally = function (args) {
    var _a, _b;
    var found = state.preferences.find(function (p) { return p.user_id === args.userId && p.kind === args.kind && p.channel === args.channel; });
    return (_a = found === null || found === void 0 ? void 0 : found.enabled) !== null && _a !== void 0 ? _a : ((_b = args.defaultEnabled) !== null && _b !== void 0 ? _b : true);
};
exports.getPreferenceEnabledLocally = getPreferenceEnabledLocally;
var resetPreferencesLocally = function () {
    state = {
        initialised: false,
        userId: null,
        unreadCount: 0,
        kinds: [],
        preferences: [],
        notificationLanguage: 'en',
    };
    emit();
};
exports.resetPreferencesLocally = resetPreferencesLocally;
var usePreferencesStore = function () {
    return (0, react_1.useSyncExternalStore)(exports.subscribePreferences, exports.getPreferencesSnapshot, exports.getPreferencesSnapshot);
};
exports.usePreferencesStore = usePreferencesStore;
var useNotificationLanguageStore = function () {
    var notificationLanguage = (0, exports.usePreferencesStore)().notificationLanguage;
    var setLanguage = function (lang) {
        setState({ notificationLanguage: lang });
    };
    return { language: notificationLanguage, setLanguage: setLanguage };
};
exports.useNotificationLanguageStore = useNotificationLanguageStore;
